module.exports = __webpack_public_path__ + "img/qhse-banner.be7cf324.png";